import { useElementSize } from '../hooks';

export const useReactiveTableHeight = () => {
  const { ref: parentRef, size: parentSize } = useElementSize();
  const { ref: toolbarRef, size: toolbarSize } = useElementSize();

  const getTableHeight = (otherHeights: (number | undefined)[] = [160], defaultHeight = 230) =>
    parentSize?.height
      ? Math.max(
          otherHeights.reduce((total = 0, curr = 0) => total - curr, parentSize.height - (toolbarSize?.height ?? 0)) ??
            parentSize?.height,
          defaultHeight,
        )
      : defaultHeight;

  return { parentRef, toolbarRef, getTableHeight };
};
